module.exports = __webpack_public_path__ + "static/img/system-2.3ba30dd9.png";